import type { AxiosRequestConfig } from 'axios';

import { api } from '../../axios.instance';

export const testSyncAlert = (config?: AxiosRequestConfig) => {
  return api.post('/sync-alert-config/test', undefined, config);
};
